export const capitalize = (string) =>
  string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
